import axios from 'axios'
import Token from '../module/token'
import store from '@/store'
import YunLinked from 'yunlinked'
 //import YunLinked from '../../../linked-js/src/index.js'

Token.en()
const http = axios.create({
  baseURL: process.env.VUE_APP_API_SUB_PATH,
})
http.interceptors.request.use((config) => {
  config.headers.common = {
    traceId: YunLinked.mainGetId(),
    deviceId: YunLinked.mainGetDeviceId(),
    // uaObj: JSON.stringify(YunLinked.getUa())||'',
    isWindow: Window ? true : false,
  }
  return config
})
http.interceptors.response.use(
  (response) => {
    const res = response.data

    return res
  },
  (err) => {
    console.log(`接口逻辑报错`, err)
    Promise.reject(err)
  }
)

const getUrlQuery = () => {
  const url = window.location.href
  const _url = url.split('?')
  if (_url.length >= 2) {
    return `?${_url[1]}`
  }
  return ''
}

// 获取省份列表
export const getProvinceList = (columnCount, cardType) => {
  return http({
    url: `/card/common/v2/resource/province/list/${columnCount}/${cardType}`,
    method: 'get',
  })
}

// 获取城市列表
export const getCityList = (params) => {
  return http({
    url: '/card/common/v2/json/get',
    method: 'get',
    params,
  })
}

// 获取可选号码列表
export const getNumbers = (data) => {
  return http({
    url: `/card/common/v2/search`,
    method: 'post',
    data,
    headers: {
      template: store.getters.templateId,
    },
  })
}

// 获取靓号列表
export const getPrettyNumbers = (data) => {
  return http({
    url: `/card/common/v2/select`,
    method: 'post',
    data,
  })
}

// 确定传入地址是否
export const postConfirmAddrss = (data) => {
  return http({
    url: `/card/common/v2/resource/province/list/match`,
    method: 'post',
    data,
  })
}

export const getPlacePoi = (params) => {
  return http({
    url: `//restapi.amap.com/v5/place/text?parameters`,
    method: 'get',
    params,
  })
}

export const postAds = (params) => {
  return http({
    url: '/monitor/common_monitor?company=' + params.query.company + '&requestMethod=' + params.query.requestMethod,
    method: 'post',
    data: params.info,
  })
}

export const recordAds = (data) => {
  http({
    url: '/monitor/record',
    method: 'post',
    data,
  })
}

// 意向单接口
export const postBeforeOrder = (data) => {
  return http({
    url: `/card/common/v2/add` + getUrlQuery(),
    method: 'post',
    data,
  })
}

// 正式单接口
export const postOrder = (data) => {
  Token.de(sessionStorage.getItem('v2-token'))
  return http({
    url: '/card/common/v2/submit' + getUrlQuery(),
    method: 'post',
    data,
    headers: {
      key: sessionStorage.getItem('v2-token'),
    },
  })
}

export const getVerifyCode = (phoneNumer) => {
  return http({
    url: `/card/common/v2/verifyCode/send/${phoneNumer}`,
    method: 'get',
  })
}

// 是否展示验证码
export const getHasVerifyCode = (params) => {
  return http({
    url: `/card/common/v2/verify/get`,
    method: 'get',
    params,
  })
}

export const getChanel = (params) =>
  http({
    url: `/channel/common/get`,
    method: 'get',
    params,
  })

export const getPositionByApi = (params) =>
  http({
    url: `/card/common/v2/location/city`,
    method: 'get',
    params,
  })

export const adApi = (data) =>
  axios({
    url: `/api/monitor/gdt`,
    method: 'post',
    params: data,
  })

// ip定位
export const getLocationIP = (type, cardType, ip) =>
  http({
    url: `/card/common/v2/location/ip/city`,
    method: 'get',
    timeout: 3000,
    params: {
      type,
      cardType,
      ip,
    },
  })

// ip定位
export const getLocationsNewIP = (type, cardType) =>
  http({
    url: `/card/common/v2/location/ip/city/binding`,
    method: 'get',
    timeout: 3000,
    params: {
      type,
      cardType,
    },
  })

//滑块验证接口
export const getAliCaptchaInfo = (data) => {
  return http({
    url: `/card/common/v2/getAliCaptchaInfo`,
    method: 'post',
    data,
  })
}
//靓号再次推荐
export const againPhoneList = (data) => {
  return http({
    url: `/card/common/v2/searchMultiple`,
    method: 'post',
    data,
  })
}
//新选号
export const getNumbersNew = (data) => {
  return http({
    url: `/card/common/v2/searchList`,
    method: 'post',
    data,
  })
}
export const getHunanTelecomRechargeUrl = (params) => {
  return http({
    url: `/card/common/v2/hndx/link`,
    method: 'get',
    params,
  })
}

// 主子卡增加一个 不走ip定位的随机省市县
export const getCloseIPCity = (params) => {
  return http({
    url: `/card/common/v2/location/ip/city/close`,
    method: 'get',
    params,
  })
}

// 移动动态协议
export const mobileProtocolApi = (data) => {
  return http({
    url: `/card/common/v2/icardMobile/protocol`,
    method: 'post',
    data,
  })
}

/**
 * 2023-11-30  下单失败切卡增加逻辑
 * @param {*} data
 * @returns
 */
export const getFailedCardApi = (data) => {
  return http({
    url: `/card/common/v2/get/failedCard`,
    method: 'post',
    data,
  })
}
export const getCheckCode = (data) => {
  return http({
    url: `/card/common/v2/getCheckCode`,
    method: 'post',
    data,
  })
}


